import { useState, useEffect } from 'react';
import { supabase } from '@/lib/supabase';
import { EXERCISE_DATABASE } from '@/constants/exerciseDatabase';
import { Exercise } from '@/types/database';

export function useExercises() {
  const [exercises, setExercises] = useState<Exercise[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadExercises();
  }, []);

  const loadExercises = async () => {
    const T = '1970-01-01T00:00:00.000Z';
    const localExercises: Exercise[] = EXERCISE_DATABASE.map((info) => {
      const id = `local-${info.name.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`;
      const bodyPart = info.primaryMuscle === 'full_body' ? 'full_body'
        : info.primaryMuscle === 'arms' ? 'arms'
        : info.primaryMuscle;
      const isBaseline = ['Back Squat', 'Deadlift', 'Bench Press', 'Weighted Pull-Up', 'Dead Hang'].includes(info.name);
      return { id, name: info.name, category: info.category, body_part: bodyPart, is_big_three: isBaseline, is_custom: false, created_at: T };
    });

    const { data, error } = await supabase.from('exercises').select('*').eq('is_custom', false).order('name');
    const remoteExercises = (!error && Array.isArray(data) && data.length > 0) ? (data as Exercise[]) : [];

    const localNames = new Set(localExercises.map((e) => e.name.toLowerCase()));
    const supplementary = remoteExercises.filter((e) => !localNames.has(e.name.toLowerCase()));
    setExercises([...localExercises, ...supplementary]);
    setLoading(false);
  };

  return { exercises, loading };
}
